import xlsxExport from '../../shared/xlsxExport/xlsxExport';
import {
  periodColumnDefinition,
  accountColumnDefinition,
  descriptionColumnDefinition,
  enabledFlagColumnDefinition,
  allowAccountBasedAdjustmentsColumnDefinition,
  preTaxColumnDefinition,
} from '../../shared/columnDefinitions';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';
import { alignLeftCellStyle } from '@common/cellStyles';

export default categories => ({
  periodName,
  entities,
  environmentSuffix,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
}) => {
  const tlsAccountsWithPeriods = entities.map(tlsAccount => ({
    periodName,
    ...tlsAccount,
  }));

  const sheetData = [
    {
      name: 'TLS Accounts',
      type: SheetExportTypes.GRID,
      columnDefinitions: [
        {
          ...periodColumnDefinition,
          rowGroup: true,
          hide: true,
          enableGroup: true,
          minWidth: 200,
        },
        accountColumnDefinition,
        descriptionColumnDefinition,
        preTaxColumnDefinition,
        enabledFlagColumnDefinition,
        allowAccountBasedAdjustmentsColumnDefinition,
        ...categories.map(({ categoryName, description }) => ({
          headerName: description,
          field: categoryName,
          minWidth: 180,
          ...alignLeftCellStyle,
          templateMeta: {
            description: `Valid ${description}`,
            required: false,
            sampleData: 'JUN-19',
          },
        })),
      ],
      data: tlsAccountsWithPeriods,
      options: {
        shouldDisplayZero,
        hideDecimals,
        negativeMinus,
      },
    },
    {
      name: 'Metadata',
      type: SheetExportTypes.CUSTOM,
      data: [],
      options: {
        addTimestamp: true,
      },
    },
  ];

  xlsxExport({
    sheetData,
    metadata: {
      fileName: `TLS_Accounts_${periodName}${environmentSuffix}`,
      disableHeaderRendering: true,
    },
  });
};
